import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPumpProgressiveCavity = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 100,
	viewBox: "0 0 100.0 100.0",
	...props,
	children: [/* @__PURE__ */ _jsx("ellipse", {
		cx: 50,
		cy: 50,
		rx: 50,
		ry: 50,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 50.0 0.0 L 100.0 50.0 L 50.0 100.0 M 25.0 50.0 A 5.0 5.0 0.0 1 1 42.5 50.0 A 5.0 5.0 0.0 1 0 57.5 50.0 A 5.0 5.0 0.0 1 1 75.0 50.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgPumpProgressiveCavity;
